import axios from 'axios';
import {
  DashboardInformation,
  LastRegisteredUsers,
  UserDiscountCodes,
  WillyDataResponse
} from './Dashboard.types';

export const getDashboardAsync = async () => {
  const { data } = await axios.get(`/backoffice/partner/user/data`);
  return data.data as DashboardInformation;
};

export const getLastRegisteredUsersAsync = async () => {
  const { data } = await axios.get(`/user/last-registered-users`, {
    params: {
      numOfUsers: 50
    }
  });
  return data.data.users as LastRegisteredUsers[];
};

export const getJoinedAfterUsersAsync = async () => {
  const { data } = await axios.get(`/backoffice/user/joined-after/count`);
  return data.data.count as number;
};

export const updatePackageRankNotificationAsync = async (
  userPackageRankHistoryId: number
) => {
  const { data } = await axios.put(`/package/rank/notification/seen`, {
    userPackageRankHistoryId
  });
  return data.data;
};

export const checkSideModalAsync = async () => {
  const { data } = await axios.put(`/user/set-side-modal-checked`);
  return data.data;
};

export const checkAkashaModalAsync = async () => {
  const { data } = await axios.put(`/user/set-akasha-popup-checked`);
  return data.data;
};

export const getWillyCoinsAsync = async () => {
  const { data } = await axios.get(`/meme-coin/progress`);

  return data.data as WillyDataResponse;
};
